import GraphAxisIntervalDisplayOptions from "./GraphAxisIntervalDisplayOptions";
import GraphAxisLegendDisplayOptions from "./GraphAxisLegendDisplayOptions";

class GraphAxisDisplayOptions {
    constructor(visible, color, thickness, scale, legend, interval) {
        this.visible = typeof visible === 'boolean' ? visible : true;
        this.color = color || black;
        this.thickness = thickness || 1;
        this.scale = scale || 1;
        this.legend = legend || new GraphAxisLegendDisplayOptions();
        this.interval = interval || new GraphAxisIntervalDisplayOptions();
    }
}
export default GraphAxisDisplayOptions;